import * as Actions from '../../actions';

const initialState = { data: null };

const producerDashboardLabAveragesReducer = function (state = initialState, action) {
    switch (action.type) {
        case Actions.GET_PRODUCER_DASHBOARD_LABAVERAGES_DETAILS:
            return { ...state, data: { ...action.payload } };

        default:
            return state;
    }
};

export default producerDashboardLabAveragesReducer;
